// extracted by mini-css-extract-plugin
export default {"modal_one":"ModalOne_modal_one__xT5kw","show_modal":"ModalOne_show_modal__12gu5","hide_model":"ModalOne_hide_model__AOKNh"};